import {Component, OnInit } from '@angular/core';
import {GridColumns} from '../../services/profile.service';
import {DashboardService, PreStudentInformationDashBoard,UsertDetailsStatus,Hallticket} from '../../services/dashboard.service';
import {Router, ActivatedRoute, NavigationExtras  } from '@angular/router';
import {Configuration } from '../../../app.constants';
import { Alert } from 'selenium-webdriver';
import { AuthService,PortalStudentLogIn } from '../../../shared/services/auth.service'
import {formatDate} from '@angular/common';
import { HelperService } from '../../../shared/services/helper.service';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  dataSource: any;
  columns: GridColumns[];
  popupVisible = false;
  popupVisible1 = false;
  popupVisible2 =false;
  ExampopupVisible=false;
  popupTitle:string;
  showButton = false; 
  public DeleteBtnDisabled:boolean;
  courseDetails:any;
  ExamDetails:any;
  userDetails:any;
  private sub: any;
  StudentID:number;
  EmailID:string;
  Password:string;
  StuPoartlaID:number;
  StuGender:string;
  MobileNo:string;
  PreStudentInformationDashBoardList: any;
  PreStudentInformationDashBoard:any=[];
  mystatus:any;
  mystatusother:any;
  customObj:any;
  popupTitleProfileLock:string="Your Profile is Locked Successfully.";
  popupVisibleProfileLock:boolean=true;
  Hallticket:any="";
  data1:any;
  form1:any;
  form2:any;
  dataPrintform:any;
  dataPrintReceipt:any;
  studData:any;
  studData1:any;
  timetabledata:any;
  timetabledata1:any;
  HallTicketStatus:any;
  ExampopupTitle:string;
  MeritGen:string;
  MeritShow:boolean=false;
  MeritNotGen:string;
   msg:string="";
  StudentPhoto:string;
  semisterWiseStudentList:any;
  isenable:boolean=true;
  PaymentReceipt:any;
  PaymentReceiptdata:any;
  coursebutton:any;
  i:number;
  profilelink:any;
  LanguageLabel:any;
  printdis:boolean=true;
  YesBtnDisabled:boolean=false;
  HallTicketButton:any;
  printform1:any;
  printReceipt:any;
  PrestudentCount:number;
  obj:any;
  PRNData:any;
  PRNNO:any;
  ResultData:any;
  Result:any="";
  HallticketData:any;
  FlagData:any;
  popupTitleProspect:string;
  popupVisibleProspect:boolean;

  popupTitle9:string="";
  popupVisible9:boolean=false;
  NewPath:string="";

  constructor(private router: Router,
    private route: ActivatedRoute
, private dashboardService: DashboardService, private Configuration: Configuration, 
  private authService: AuthService,private HelperService:HelperService
          ) {
    this.columns = dashboardService.getGridColumns();
    
    this.userDetails = [];
    this.userDetails = dashboardService.getUserDetails();
    this.StudentPhoto = this.Configuration.PhotoPath;
    
  }
  popupHiding(e) {
    this.showButton = true;
  };
  ngOnInit() {
    debugger;
    this.LanguageLabel =this.Configuration.LanguageLabel[0];
    if(this.Configuration.StudentID==0){
      this.printdis=true;
    }
    /* if(this.Configuration.FromProspect==true){
      this.popupVisibleProspect=false;
    }else{
      this.popupVisibleProspect=true;
      this.popupTitleProspect="Download Prospect";
    } */
    //change 7-8-2020
   
    if(this.Configuration.ProspectFlag=="Y" && this.Configuration.ProspectPurchaseFlag=="Y"){
      if (this.Configuration.prospectshow ==0) {
        if(this.Configuration.loggedstatus=="Y"){
          this.popupVisibleProspect=false;
          this.popupTitleProspect="Prospect";
        }else{
          this.popupVisibleProspect=true;
          this.popupTitleProspect="Download Prospect";
        }
      }else{
        this.popupVisibleProspect=false;
        this.popupTitleProspect="Prospect";
      }
    }else if (this.Configuration.ProspectFlag =="N" && this.Configuration.ProspectPurchaseFlag=="N"){
      this.popupVisibleProspect=false;
      this.popupTitleProspect="Prospect";
    }else if(this.Configuration.ProspectFlag=="Y" && this.Configuration.ProspectPurchaseFlag=="N"){
      if(this.Configuration.loggedstatus=="Y"){
        this.popupVisibleProspect=false;
        this.popupTitleProspect="Prospect";
      }else{
        this.popupVisibleProspect=true;
        this.popupTitleProspect="Download Prospect";
      }
    }
    if(this.Configuration.StudentID>0){
      this.printdis=false;

      this.authService.GetPRNNoByStudentID(this.Configuration.StudentID)
      .subscribe((data: PortalStudentLogIn[]) => this.PRNData= data,
        error => {
          alert(error);
        },
        () => {
          
         if(this.PRNData.length>0) {
           this.PRNNO=this.PRNData[0].PRNString;
               
         }
        /*  if(this.Configuration.ProspectFlag=="Y" && this.Configuration.ProspectPurchaseFlag=="Y"){
            if (this.Configuration.prospectshow ==0) {
              this.popupVisibleProspect=true;
              this.popupTitleProspect="Download Prospect";
            }else{
              this.popupVisibleProspect=false;
              this.popupTitleProspect="Prospect";
            }
          }else if (this.Configuration.ProspectFlag =="N" && this.Configuration.ProspectPurchaseFlag=="N"){
            this.popupVisibleProspect=false;
            this.popupTitleProspect="Prospect";
          } */
        }
      );
    
    
    /* this.dashboardService.getExamdashboardData(this.Configuration.StudentID) //6123          
    .subscribe((data: PreStudentInformationDashBoard[]) => this.semisterWiseStudentList = data,
    error => {
    },
    () => {
      
    }); */
    
  }
     this.sub = this.route.queryParams.subscribe(params => {
      let StudentID = params["StudentID"];
      this.StudentID =StudentID;
      let EmailID = params["EmailID"];
      this.EmailID =EmailID;
      let StuPoartlaID = params["StuPoartlaID"];
      this.StuPoartlaID =StuPoartlaID; 
      let StuGender = params["StuGender"];
      this.StuGender =StuGender; 
      let MobileNo = params["MobileNo"];
      this.MobileNo =MobileNo; 
         });
       
         this.shwodata();
         
  }
  shwodata(){
    this.sub = this.route.queryParams.subscribe(params => {
      let StudentID = params["StudentID"];
      this.StudentID =this.Configuration.StudentID ;//StudentID;
      let EmailID = params["EmailID"];
      this.EmailID =EmailID;
      let StuPoartlaID = params["StuPoartlaID"];
      this.StuPoartlaID =StuPoartlaID; 
      let StuGender = params["StuGender"];
      this.StuGender =StuGender; 
      let MobileNo = params["MobileNo"];
      this.MobileNo =MobileNo; 
         });
         
    if(this.Configuration.StudentID>0)
         {
           
          this.dashboardService.getPreStudentdashboardData(this.Configuration.StudentID,this.Configuration.AcademicInstanceID) //6123          
          .subscribe((data: PreStudentInformationDashBoard[]) =>{ 
            
            this.PreStudentInformationDashBoard = this.createRowIndex(data);
          },
          error => {
         alert(error);
          },
          () => {
                      if(this.PreStudentInformationDashBoard.length>0){
                        this.PrestudentCount=1;

                      }
           
                  if(this.PreStudentInformationDashBoard.length==0){
                    this.PrestudentCount=0;
                    this.dashboardService.getdashboardData(this.Configuration.StudentID,this.Configuration.AcademicInstanceID) //6123          
                    .subscribe((data: PreStudentInformationDashBoard[]) =>{ 
                      
                      this.PreStudentInformationDashBoard = this.createRowIndex(data);
                       if( this.PreStudentInformationDashBoard[0].GMerit>0){
                        this.MeritShow=true;
                      } 
                    },
                    error => {
                   alert(error);
                    },
                    () => {
                        
                     
                    }); 
                    
                  }
                  this.dashboardService.getdUserDetailsStatusFromPortal(this.StudentID) //6123          
                  .subscribe((data: UsertDetailsStatus[]) => this.dataSource = data,
                  error => {
                  },
                  () => {
                      debugger
                      this.mystatusother=[];
                      this.mystatus=[];
                      for(var i=0;i<this.dataSource.length;i++){
                        //if(this.dataSource[i].StatusID == 8  || this.dataSource[i].StatusID==9 || this.dataSource[i].StatusID==10 || this.dataSource[i].StatusID==11 || this.dataSource[i].StatusID==12 || this.dataSource[i].StatusID==13 ){
                        if(this.dataSource[i].StatusID == 8){
                            this.customObj=[];
                            this.customObj.StatusName = this.dataSource[i].StatusName;
                            this.customObj.StatusID = this.dataSource[i].StatusID;
                            this.customObj.StatusFlag = this.dataSource[i].StatusFlag;
                            if(this.dataSource[i].StatusFlag =="Y"){
                              this.customObj.chk=true;
                            }else{
                              this.customObj.chk=false;
                            }
                            this.mystatusother.push(this.customObj);
                        }else{
                            this.customObj=[];
                            this.customObj.StatusName = this.dataSource[i].StatusName;
                            this.customObj.StatusID = this.dataSource[i].StatusID;
                            this.customObj.StatusFlag = this.dataSource[i].StatusFlag;
                            if(this.dataSource[i].StatusFlag =="Y"){
                              this.customObj.chk=true;
                            }else{
                              this.customObj.chk=false;
                            }
                            this.mystatus.push(this.customObj);
                      }
                    }
                      this.PreStudentInformationDashBoard.StudentPhoto= this.Configuration.PhotoPath;
                      this.userDetails.profilePicPath= this.Configuration.PhotoPath;
                  });  
              });
         }
         else{
              this.PreStudentInformationDashBoard =[];
              this.filldefaultstatus();
         }
  }
  createRowIndex(preStudentInformationDashBoard: any) {
    if (preStudentInformationDashBoard) {
      for (var i = 0; i < preStudentInformationDashBoard.length; i++) {
        var studentInfo = preStudentInformationDashBoard[i];
        studentInfo.rowIndex = (i + 1);
      }
    }
    return preStudentInformationDashBoard
  }
  filldefaultstatus(){
    this.dataSource = this.dashboardService.GetprofileStatusdefault();
    this.mystatusother=[];
    this.mystatus=[];
      for(var i=0;i<this.dataSource.length;i++){
        if(this.dataSource[i].StatusID == 8 || this.dataSource[i].StatusID==9){
            this.customObj=[];
            this.customObj.StatusName = this.dataSource[i].StatusName;
            this.customObj.StatusID = this.dataSource[i].StatusID;
            this.customObj.StatusFlag = this.dataSource[i].StatusFlag;
            if(this.dataSource[i].StatusFlag =="Y"){
              this.customObj.chk=true;
            }else{
              this.customObj.chk=false;
            }
            this.mystatusother.push(this.customObj);
        }else{
            this.customObj=[];
            this.customObj.StatusName = this.dataSource[i].StatusName;
            this.customObj.StatusID = this.dataSource[i].StatusID;
            this.customObj.StatusFlag = this.dataSource[i].StatusFlag;
            if(this.dataSource[i].StatusFlag =="Y"){
              this.customObj.chk=true;
            }else{
              this.customObj.chk=false;
            }
            this.mystatus.push(this.customObj);
      }
    }
  }
  showInfo() {
    this.popupVisible = true;
  }
  pofilelock(){
  
    this.dashboardService.GetProfileLockStatusForAdmissionForm(this.Configuration.StudentID) //6123          
          .subscribe((data: UsertDetailsStatus[]) => this.dataSource = data,
          error => {
        alert(error);
          },
          () => {
            
            if(this.dataSource[0].AddressInfoStatusFlag =="Y" && 
            this.dataSource[0].PersonalInfoIIStatusFlag =="Y" && this.dataSource[0].CommonDocumentStatusFlag == "Y" &&
            this.dataSource[0].PersonalInfoIStatusFlag =="Y" && this.dataSource[0].PhotoSignatureStatusFlag =="Y" &&
            this.dataSource[0].PrevEducationStatusFlag =="Y" && this.dataSource[0].SocialReservationStatusFlag =="Y" 
            )
            {
              
              if(this.dataSource[0].ProfileLockStatusFlag =="Y"){
                this.popupVisible2 =true;
                this.msg= this.LanguageLabel.SPINSTR18;  
              }else{
                this.popupVisible1 =true;
                this.msg=this.LanguageLabel.SPINSTR19;
              }
             
            }else{
              this.popupVisible2 =true;
              this.msg=this.LanguageLabel.SPINSTR21;
              return;
            }
        }); 
  }
  ProfilelockconfirmYes(){
    this.YesBtnDisabled=true;
      this.dashboardService.getupdateprofilelock(this.Configuration.StudentID) //6123          
      .subscribe((data: UsertDetailsStatus[]) => this.dataSource = data,
      error => {
      alert(error);
        },
        () => {
          
          this.onSuccessProfileLock();
          this.YesBtnDisabled=false;
          this.popupVisible1 =false;
      });  
  }
  ProfilelockconfirmNo(){
    this.popupVisible1 =false;
  }
  confirmOK(){
    this.popupVisible2 =false;
  }
  
  onCloseButton() {
    this.popupVisible = false;
    this.DeleteBtnDisabled = true;
    this.shwodata();
  }

  
    
  onFocusedRowChanging(e) {
    var rowsCount = e.component.getVisibleRows().length,
      pageCount = e.component.pageCount(),
      pageIndex = e.component.pageIndex();

    if (e.event.key && e.prevRowIndex === e.newRowIndex) {
      if (e.newRowIndex === rowsCount - 1 && pageIndex < pageCount - 1) {
        e.component.pageIndex(pageIndex + 1).done(function () {
          e.component.option("focusedRowIndex", 0);
        });
      } else if (e.newRowIndex === 0 && pageIndex > 0) {
        e.component.pageIndex(pageIndex - 1).done(function () {
          e.component.option("focusedRowIndex", rowsCount - 1);
        });
      }
    }
  }
  selectionChangedHandler(e) {
    this.DeleteBtnDisabled = false;
    var component = e.component;
    var applicationStatus=e.data.ApplicationStatus
    if (!component.clickCount)
      component.clickCount = 1;
    else
      component.clickCount = component.clickCount + 1;
    if (component.clickCount == 1) {
      component.lastClickTime = new Date();
      setTimeout(function () { component.lastClickTime = 0; component.clickCount = 0; }, 350);
    }
    else if (component.clickCount == 2) {
      const date: Date = new Date();
      if ((Number(date) - component.lastClickTime) < 300) {
        debugger;
        this.popupTitle=this.LanguageLabel.ApplicationStatus;
        this.courseDetails=[];
        this.courseDetails = e.data;
        
        this.courseDetails.userName=this.userDetails.userName ;
        this.courseDetails.profilePicPath= this.Configuration.PhotoPath;
        this.PreStudentInformationDashBoard.StudentPhoto= this.Configuration.PhotoPath;
        this.showInfo();
      }
    
        
      component.clickCount = 0;
      component.lastClickTime = 0;
    }
  }

  printHallTicket() {
 alert('print Hall Ticket');
    this.dashboardService.getHallTicketByStudentID(this.Configuration.StudentID)
    .subscribe((data: Hallticket[]) => this.Hallticket = data,
      error => {
        alert(error);
      },
      () => {
        this.data1=this.Hallticket.Message;
   
        window.open(this.Hallticket.Message,"_blank"); 
     });

  }
 
onFocusedRowChanging1(e) {
  
  var rowsCount = e.component.getVisibleRows().length,
      pageCount = e.component.pageCount(),
      pageIndex = e.component.pageIndex();
      if(e.rowType != "group"){
    if (e.event.key && e.prevRowIndex === e.newRowIndex) {
      if (e.newRowIndex === rowsCount - 1 && pageIndex < pageCount - 1) {
        e.component.pageIndex(pageIndex + 1).done(function () {
          e.component.option("focusedRowIndex", 0);
        });
      } else if (e.newRowIndex === 0 && pageIndex > 0) {
        e.component.pageIndex(pageIndex - 1).done(function () {
          e.component.option("focusedRowIndex", rowsCount - 1);
        });
      }
    }
  }
}
selectionChangedHandler1(e) {debugger
  if(e.rowType != "group"){
 var component = e.component;
  if (!component.clickCount)
    component.clickCount = 1;
  else
    component.clickCount = component.clickCount + 1;
  if (component.clickCount == 1) {
    var data = e.data;
    component.lastClickTime = new Date();
  
  }
  else if (component.clickCount == 2) {
    const date: Date = new Date();
          
      var data = e.data;
      var CourseButton1='';
      var CourseButton2='';
      this.ExamDetails =e.data;
      this.ExampopupTitle=this.LanguageLabel.Program+' '+this.LanguageLabel.Status;
      if(this.ExamDetails.AcademicInstanceID ==this.Configuration.AcademicInstanceID){
        this.ExampopupVisible=true;
      }
    component.clickCount = 0;
    component.lastClickTime = 0;
  }
}

} 
getResult(e){debugger
  window.open(this.Result,'_blank');
}
  onSuccessProfileLock() {
    this.HelperService.showSuccessMessage("Your Profile Locked Successfully.");    
  }
  onClickNotifications(){
    this.popupVisible9=true;
  }
}


